let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bD6YK")).then(() => parcelRequire('71tek'));